import { createContext, useContext, useEffect, useState } from "react";
import client, { formatApiError } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await client.get("/auth/me");
        setUser(data);
      } catch { setUser(null); }
      setLoading(false);
    })();
  }, []);

  const login = async (email, password) => {
    const { data } = await client.post("/auth/login", { email, password });
    if (data.token) localStorage.setItem("token", data.token);
    setUser(data);
    return data;
  };
  const register = async (name, email, password, role="customer") => {
    const { data } = await client.post("/auth/register", { name, email, password, role });
    if (data.token) localStorage.setItem("token", data.token);
    setUser(data);
    return data;
  };
  const logout = async () => {
    try { await client.post("/auth/logout"); } catch {}
    localStorage.removeItem("token");
    setUser(null);
  };
  const refreshUser = async () => {
    try { const { data } = await client.get("/auth/me"); setUser(data); return data; }
    catch { return null; }
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, logout, refreshUser, formatApiError }}>
      {children}
    </AuthCtx.Provider>
  );
}
